import { axiosInstance as axios } from "services";

export const downloadPaymentHistoryCSV = async (companyId, params) => {
  const response = await axios.get(`/admin/subscription/company/${companyId}/payment-history-detail`, {
    params: { ...params, format: "csv" },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payment_history_${companyId}_${new Date().getTime()}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
